// extracted by mini-css-extract-plugin
export default {"errorBlock":"styles_errorBlock__McChB","icon":"styles_icon__xAxZO","message":"styles_message__OaZB+"};